export default {

    init() {
        // initial process
        this.process(document);

        return this;
    },

    process(scope) {
        $(scope).find('img.dark-mode').each(async (index, el) => {
            await this.processElement(el);
        });
    },

    async processElement(el, src = null) {
        if (src === null) {
            src = el.attributes.getNamedItem('src')?.value;
        }

        if (!src) {
            throw new Error('Source not defined for element');
        }

        el.src = Syn.theme.id === 'dark' ?
            await this.getTransparentImageStringFromSource(
                src
            ) : src;
        el.classList.add('show');
    },

    async getTransparentImageStringFromSource(src) {
        const backgroundColor = { red: 255, green: 255, blue: 255 };
        const threshold = 80;

        const imageElement = new Image();
        imageElement.crossOrigin = "anonymous";
        imageElement.src = src;
        await new Promise(function(resolve) { imageElement.addEventListener('load', resolve); });

        var canvas = document.createElement('canvas');
        canvas.width = imageElement.naturalWidth;
        canvas.height = imageElement.naturalHeight;

        var ctx = canvas.getContext('2d');
        ctx.drawImage(imageElement, 0, 0);
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        for (var i = 0; i < imageData.data.length; i += 4) {
            const red = imageData.data[i];
            const green = imageData.data[i + 1];
            const blue = imageData.data[i + 2];
            if (Math.abs(red - backgroundColor.red) < threshold &&
                Math.abs(green - backgroundColor.green) < threshold &&
                Math.abs(blue - backgroundColor.blue) < threshold) {
                imageData.data[i + 3] = 0;
            }
        }
        ctx.putImageData(imageData, 0, 0);
        return canvas.toDataURL(`image/png`);
    },

}
